import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useConnectWs from "../../../hooks/useConnectWs";
import {
  showBalanceWithSpanLayout,
  formatNumber,
  formatNumberOnly,
} from "../../../utils/Helpers";
import { useNavigate } from "react-router-dom";
import routes from "../../../constants/routes";
import axios from "axios";

const Coin = () => {
  formatNumber();
  const { t } = useTranslation();
  const [accountInfo, setAccountInfo] = useState(null);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [api, setApi] = useConnectWs();
  const history = useNavigate();
  const { account } = useSelector((state) => state.account);

  const handleRequestVBI = async () => {
    try {
      setLoadingRequest(true);
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL + "api/tokens/faucet"}`,
        data: {
          wallet_address: account?.address,
        },
      });
    } catch (error) {
      console.log("handleRequestVBI error", error);
      setLoadingRequest(false);
    }
  };

  useEffect(() => {
    if (!account) {
      history(routes?.connect);
    }
  }, [account]);

  useEffect(() => {
    if (account && api) {
      (async function () {
        var accountInfo = await api.query.system.account(account?.address);
        setAccountInfo(accountInfo);
        api.query.system.account.multi([account?.address], (balances) => {
          setAccountInfo((prev) => ({
            ...prev,
            data: {
              ...prev.data,
              free: balances.map(({ data: { free } }) => free)[0],
            },
          }));
        });
      })();
    }
  }, [account, api]);

  return (
    <div className="box">
      <div className="top">
        <div className="left">Coins</div>
      </div>
      <div className="body">
        <div className="item">
          <div className="left">
            <div className="image">
              <img src="/images/vbi.png" alt="" />
            </div>
            <div className="text">
              <div className="title">VBI</div>
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: showBalanceWithSpanLayout(accountInfo?.data?.free),
                }}
              ></div>
            </div>
          </div>
          <div className="buttons">
            <div
              className="button"
              onClick={() => history(routes.sendToken + "?symbol=VBI")}
            >
              <img src="/images/wallet2.svg" alt="" />
              {t("wallet.Send")}
            </div>
            <button
              disabled={loadingRequest}
              className="button"
              onClick={handleRequestVBI}
            >
              {loadingRequest ? <>Requesting...</> : <>Request VBI</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Coin;
